import { render, staticRenderFns } from "./CourseCatalog.vue?vue&type=template&id=1e39e24e&scoped=true"
import script from "./CourseCatalog.vue?vue&type=script&lang=js"
export * from "./CourseCatalog.vue?vue&type=script&lang=js"
import style0 from "./CourseCatalog.vue?vue&type=style&index=0&id=1e39e24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e39e24e",
  null
  
)

export default component.exports